import {
  Box,
  Button,
  Dialog,
  IconButton,
  Paper,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Popover,
  Checkbox,
  Typography,
  Autocomplete,
  Menu,
  MenuItem,
  Divider,
  CircularProgress,
  Chip,
  Collapse,
  Grid,

} from "@mui/material";
import {
  Delete as DeleteIcon,
  Edit,
  Print,
  ExpandMore,
  ExpandLess,
  Description as FileIcon,
  Close as CloseIcon,
  Visibility,
} from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import InfiniteScroll from "react-infinite-scroll-component";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useMediaQuery, useTheme } from "@mui/material";
import {
  ProformaInvoiceExportApi,
  ProformaInvoiceListApi,
  ProformaInvoiceDelete,
  ApproveProformaInvoice,
  DivisionList,
} from "../../../Services/Services";
import { printPerforma } from "./performaPrint";

const ProformaInvoiceTable = () => {
  const stored = localStorage.getItem("selectedDivision");
  const divisionLocalStorage = JSON.parse(stored);
  const [filters, setFilters] = useState({
    division: "",
    pi_no: "",
    project_name: "",
    date_range: "this_month",
    pi_date_from: "",
    pi_date_to: "",
  });

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [expandedPI, setExpandedPI] = useState(null);

  const [piDateMenuAnchor, setPiDateMenuAnchor] = useState(null);
  const [piDateRange, setPiDateRange] = useState({ from: "", to: "" });
  const [tempPiDateRange, setTempPiDateRange] = useState({ from: "", to: "" });

  const [proformas, setProformas] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [invoiceToDelete, setInvoiceToDelete] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const navigate = useNavigate();
  const [piToApprove, setPIToApprove] = useState(null);
  const [remarkInput, setRemarkInput] = useState("");
  const userRole = localStorage.getItem("role");
  const [divisionLists, setDivisionLists] = useState([]);
  const [dateMenuAnchor, setDateMenuAnchor] = useState(null);
  const [isExcelLoading, setExcelLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [approvalDialogOpen, setApprovalDialogOpen] = useState(false);
  const [filterLoading, setFilterLoading] = useState(false); // ✅ NEW - For filter changes only
  const [showCustomDateInputs, setShowCustomDateInputs] = useState(false);
  const [tempCustomDateRange, setTempCustomDateRange] = useState({
    from: "",
    to: "",
  });
  const [customDateRange, setCustomDateRange] = useState({ from: "", to: "" });

  const styles = {
    table: {
      width: "100%",
      borderCollapse: "collapse",
      fontFamily: "Arial, sans-serif",
      fontSize: "11px",
      color: "#000",
    },
    cell: {
      border: "1px solid #000",
      padding: "4px 6px",
      verticalAlign: "top",
      lineHeight: "1.4",
    },
    headerCell: {
      border: "1px solid #000",
      padding: "4px 6px",
      fontWeight: "bold",
      textAlign: "center",
      backgroundColor: "#fff",
      verticalAlign: "middle",
    },
    bold: {
      fontWeight: "bold",
    },
    redHeader: {
      color: "red",
      textAlign: "center",
      fontWeight: "bold",
      fontSize: "18px",
      padding: "10px",
      border: "1px solid #000",
      borderBottom: "none",
    },
  };

  const handleExcelExport = async () => {
    if (proformas.length === 0) {
      toast.warning("No data available to export");
      return;
    }

    setExcelLoading(true);
    try {
      const params = { ...filters };
      if (
        filters.date_range === "custom" &&
        customDateRange.from &&
        customDateRange.to
      ) {
        params.from_date = customDateRange.from;
        params.to_date = customDateRange.to;
      }

      if (filters.pi_date_from && filters.pi_date_to) {
        params.pi_date_from = filters.pi_date_from;
        params.pi_date_to = filters.pi_date_to;
      }

      const blob = await ProformaInvoiceExportApi(params);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Proforma_Invoices_${new Date().getTime()}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      toast.success("Excel downloaded successfully!");
    } catch (error) {
      console.error("Export error:", error);
      toast.error("Failed to export Excel");
    } finally {
      setExcelLoading(false);
    }
  };

  useEffect(() => {
    const fetchDivisions = async () => {
      try {
        const divisions = await DivisionList();
        setDivisionLists(
          Array.isArray(divisions) ? divisions : divisions?.results || []
        );
      } catch (error) {
        console.error("Error fetching divisions:", error);
        toast.error("Failed to load divisions");
      }
    };
    fetchDivisions();
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      setPage(1);
      fetchProformas(1, filters, true);
    }, 500);

    return () => clearTimeout(handler);
  }, [filters, customDateRange, piDateRange]);

  const fetchProformas = async (
    pageNum = 1,
    filterObj = filters,
    reset = false
  ) => {
    try {
      if (reset) {
        setFilterLoading(true);
      } else {
        setLoading(true);
      }
      const params = { ...filterObj };

      if (
        filterObj.date_range === "custom" &&
        customDateRange.from &&
        customDateRange.to
      ) {
        params.from_date = customDateRange.from;
        params.to_date = customDateRange.to;
      }

      if (filterObj.pi_date_from && filterObj.pi_date_to) {
        params.pi_date_from = filterObj.pi_date_from;
        params.pi_date_to = filterObj.pi_date_to;
      }

      const res = await ProformaInvoiceListApi(pageNum, params);

      if (reset || pageNum === 1) {
        setProformas(res.results || []);
      } else {
        setProformas((prev) => [...prev, ...(res.results || [])]);
      }

      setHasMore(res.next !== null);
      setPage(pageNum);
    } catch (error) {
      console.error("❌ Failed to fetch sales orders:", error);
      toast.error("Failed to load sales orders");
    } finally {
      // ✅ Reset the appropriate loading state
      setFilterLoading(false);
      setLoading(false);
    }
  };

  const fetchMoreData = () => {
    if (!hasMore) return;
    const nextPage = page + 1;
    fetchProformas(nextPage, filters);
  };

  const executeApproval = async (status) => {
    if (status === "Rejected" && !remarkInput.trim()) {
      toast.error("Remark is required for rejection!");
      return;
    }

    const approvedById = Number(localStorage.getItem("user_id"));
    if (!approvedById) {
      toast.error("Approver ID not found.");
      return;
    }

    const piId =
      piToApprove?.invoice_number || piToApprove?.invoice?.invoice_number;
    if (!piId) {
      toast.error("PI ID is undefined.");
      return;
    }

    try {
      await ApproveProformaInvoice(piId, approvedById, status, remarkInput);

      const updatedList = await ProformaInvoiceListApi(1, filters);
      setProformas(updatedList.results || []);

      toast.success(
        status === "Approved"
          ? "PI approved successfully!"
          : "PI rejected successfully!"
      );

      setApprovalDialogOpen(false);
      setRemarkInput("");
      setPIToApprove(null);
    } catch (error) {
      console.error("Approval Error:", error);
      toast.error("Failed to process approval.");
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleReset = () => {
    setFilters({
      division: "",
      pi_no: "",
      project_name: "",
      date_range: "today",
      pi_date_from: "",
      pi_date_to: "",
    });
    setCustomDateRange({ from: "", to: "" });
    setPage(1);
    setTempCustomDateRange({ from: "", to: "" });
    setShowCustomDateInputs(false);
    setPiDateRange({ from: "", to: "" });
    setTempPiDateRange({ from: "", to: "" });
  };

  const handleCancelCustomDateRange = () => {
    setTempCustomDateRange({ from: "", to: "" });
    setShowCustomDateInputs(false);
  };

  const handleApplyCustomDateRange = () => {
    if (tempCustomDateRange.from && tempCustomDateRange.to) {
      setCustomDateRange({
        from: tempCustomDateRange.from,
        to: tempCustomDateRange.to,
      });
      setFilters((prev) => ({ ...prev, date_range: "custom" }));
      setDateMenuAnchor(null);
      setShowCustomDateInputs(false);
    } else {
      toast.warning("Please select both From and To dates");
    }
  };

  const handleDelete = async (invoiceNumber) => {
    if (!invoiceNumber) {
      toast.error("Invalid invoice number.");
      return;
    }

    try {
      const res = await ProformaInvoiceDelete(invoiceNumber);

      if (res && res.message !== "Not found") {
        toast.success("Invoice deleted successfully.");
        const data = await ProformaInvoiceListApi();
        setProformas(data.results || []);
      } else {
        toast.error("Failed to delete invoice.");
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Failed to delete invoice.");
    }
    setAnchorEl(null);
  };

  const truncateText = (text, limit = 20) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  function formatOnlyDate(dateTimeString) {
    if (!dateTimeString) return "N/A";
    const datePart = dateTimeString.split("T")[0];
    const [year, month, day] = datePart.split("-");
    return `${day}-${month}-${year}`;
  }

  const formatDateDisplay = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  const getDateRangeDisplay = (rangeType) => {
    const now = new Date();
    const formatDate = (date) => {
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    switch (rangeType) {
      case "today":
        return formatDate(now);
      case "yesterday":
        const yesterday = new Date(now);
        yesterday.setDate(yesterday.getDate() - 1);
        return formatDate(yesterday);
      case "this_week":
        const weekStart = new Date(now);
        weekStart.setDate(weekStart.getDate() - weekStart.getDay() + 1);
        return `${formatDate(weekStart)} to ${formatDate(now)}`;
      case "previous_week":
        const prevWeekEnd = new Date(now);
        prevWeekEnd.setDate(prevWeekEnd.getDate() - prevWeekEnd.getDay());
        const prevWeekStart = new Date(prevWeekEnd);
        prevWeekStart.setDate(prevWeekStart.getDate() - 6);
        return `${formatDate(prevWeekStart)} to ${formatDate(prevWeekEnd)}`;
      case "this_month":
        const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
        return `${formatDate(monthStart)} to ${formatDate(now)}`;
      case "current_year":
        const yearStart = new Date(now.getFullYear(), 0, 1);
        return `${formatDate(yearStart)} to ${formatDate(now)}`;
      case "financial_year":
        let fyStart;
        if (now.getMonth() >= 3) {
          fyStart = new Date(now.getFullYear(), 3, 1);
        } else {
          fyStart = new Date(now.getFullYear() - 1, 3, 1);
        }
        return `${formatDate(fyStart)} to ${formatDate(now)}`;
      default:
        return "";
    }
  };

  const handleApplyPiDateRange = () => {
    setPiDateRange(tempPiDateRange);
    setFilters((prev) => ({
      ...prev,
      pi_date_from: tempPiDateRange.from,
      pi_date_to: tempPiDateRange.to,
      date_range: "all",
    }));
    setPiDateMenuAnchor(null);
  };

  const handleCancelPiDateRange = () => {
    setTempPiDateRange(piDateRange);
    setPiDateMenuAnchor(null);
  };

  const handleClearPiDateRange = () => {
    setPiDateRange({ from: "", to: "" });
    setTempPiDateRange({ from: "", to: "" });
    setFilters((prev) => ({
      ...prev,
      pi_date_from: "",
      pi_date_to: "",
    }));
    setPiDateMenuAnchor(null);
  };

  const MobileProformaCard = ({ invoice, index }) => {
    const isExpanded = expandedPI === invoice.invoice_number;

    return (
      <Box key={invoice.invoice_number}>
        <Box
          onClick={() =>
            setExpandedPI(
              expandedPI === invoice.invoice_number
                ? null
                : invoice.invoice_number
            )
          }
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            p: 1.5,
            cursor: "pointer",
            bgcolor: index % 2 === 0 ? "#fafafa" : "#ffffff",
            "&:active": {
              bgcolor: "#e3f2fd",
            },
            borderLeft: `4px solid ${invoice.status === "Approved"
                ? "#4caf50"
                : invoice.status === "Rejected"
                  ? "#f44336"
                  : "#ff9800"
              }`,
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Box
              sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}
            >
              <Typography
                sx={{ fontSize: "0.7rem", color: "#666", minWidth: 25 }}
              >
                #{index + 1}
              </Typography>
              <Typography
                sx={{ fontWeight: "bold", fontSize: "0.85rem", flex: 1 }}
              >
                {invoice.pi_no || "N/A"}
              </Typography>
            </Box>

            <Typography
              sx={{
                fontSize: "0.75rem",
                color: "#666",
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <span style={{ fontWeight: 500 }}>
                {invoice.project?.party_details?.company_name?.substring(
                  0,
                  20
                ) || "N/A"}
              </span>
              <span style={{ color: "#999" }}>•</span>
              <span style={{ fontSize: "0.7rem" }}>
                {formatOnlyDate(invoice.created_at)}
              </span>
            </Typography>
          </Box>

          <IconButton size="small" sx={{ ml: 1 }}>
            {isExpanded ? (
              <ExpandLess fontSize="small" />
            ) : (
              <ExpandMore fontSize="small" />
            )}
          </IconButton>
        </Box>

        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
          <Box
            sx={{
              px: 1.5,
              py: 1,
              bgcolor: index % 2 === 0 ? "#f8f9fa" : "#fafafa",
              borderLeft: `4px solid ${invoice.status === "Approved"
                  ? "#4caf50"
                  : invoice.status === "Rejected"
                    ? "#f44336"
                    : "#ff9800"
                }`,
            }}
          >
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 0.8,
                mb: 1,
              }}
            >
              <Box>
                <Typography
                  sx={{
                    fontSize: "0.6rem",
                    color: "#999",
                    letterSpacing: "0.5px",
                  }}
                >
                  STATUS
                </Typography>
                <Chip
                  label={invoice.status || "Pending"}
                  color={
                    invoice.status === "Approved"
                      ? "success"
                      : invoice.status === "Rejected"
                        ? "error"
                        : "warning"
                  }
                  size="small"
                  sx={{ height: 20, fontSize: "0.65rem", mt: 0.3 }}
                />
              </Box>

              {/* <Box>
                <Typography
                  sx={{
                    fontSize: "0.6rem",
                    color: "#999",
                    letterSpacing: "0.5px",
                  }}
                >
                  DIVISION
                </Typography>
                <Typography
                  sx={{ fontSize: "0.72rem", fontWeight: 500, color: "#555" }}
                >
                  {invoice.project?.division_name || "-"}
                </Typography>
              </Box> */}

              <Box>
                <Typography
                  sx={{
                    fontSize: "0.6rem",
                    color: "#999",
                    letterSpacing: "0.5px",
                  }}
                >
                  PI AMOUNT
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    color: "#2e7d32",
                  }}
                >
                  ₹{" "}
                  {Number(invoice.advance_received || 0).toLocaleString(
                    "en-IN",
                    {
                      minimumFractionDigits: 1,
                      maximumFractionDigits: 1,
                    }
                  )}
                </Typography>
              </Box>

              <Box>
                <Typography
                  sx={{
                    fontSize: "0.6rem",
                    color: "#999",
                    letterSpacing: "0.5px",
                  }}
                >
                  RECEIVED
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.72rem",
                    fontWeight: 500,
                    color: "#1976d2",
                  }}
                >
                  ₹{" "}
                  {Number(invoice.receive_amt || 0).toLocaleString("en-IN", {
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                  })}
                </Typography>
              </Box>

              {invoice.created_by_po && (
                <Box>
                  <Typography
                    sx={{
                      fontSize: "0.6rem",
                      color: "#999",
                      letterSpacing: "0.5px",
                    }}
                  >
                    CREATED BY
                  </Typography>
                  <Typography
                    sx={{ fontSize: "0.72rem", fontWeight: 500, color: "#555" }}
                  >
                    {invoice.created_by_po}
                  </Typography>
                </Box>
              )}

              {/* {invoice.approved_name && (
                <Box>
                  <Typography
                    sx={{
                      fontSize: "0.6rem",
                      color: "#999",
                      letterSpacing: "0.5px",
                    }}
                  >
                    APPROVED BY
                  </Typography>
                  <Typography
                    sx={{ fontSize: "0.72rem", fontWeight: 500, color: "#555" }}
                  >
                    {invoice.approved_name}
                  </Typography>
                </Box>
              )} */}
            </Box>

            {invoice.project?.project_name && (
              <Box sx={{ mb: 0.8 }}>
                <Typography
                  sx={{
                    fontSize: "0.6rem",
                    color: "#999",
                    letterSpacing: "0.5px",
                    mb: 0.3,
                  }}
                >
                  PROJECT
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.7rem",
                    color: "#555",
                    lineHeight: 1.3,
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {invoice.project.project_name}
                </Typography>
              </Box>
            )}

            {/* {invoice.remarks && (
              <Box sx={{ mb: 0.8 }}>
                <Typography
                  sx={{
                    fontSize: "0.6rem",
                    color: "#999",
                    letterSpacing: "0.5px",
                    mb: 0.3,
                  }}
                >
                  REMARKS
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.7rem",
                    color: "#555",
                    fontStyle: "italic",
                    lineHeight: 1.3,
                  }}
                >
                  {invoice.remarks}
                </Typography>
              </Box>
            )} */}

            <Divider sx={{ my: 1, borderColor: "#e0e0e0" }} />

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 1,
              }}
            >

              {userRole != "Staff" && (
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    setPIToApprove(invoice);
                    setApprovalDialogOpen(true);
                  }}
                  sx={{
                    bgcolor: "#e3f2fd",
                    borderRadius: "6px",
                    width: 32,
                    height: 32,
                    "&:hover": { bgcolor: "#bbdefb" },
                  }}
                >
                  <Visibility sx={{ fontSize: "1rem", color: "#1976d2" }} />
                </IconButton>
              )}
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  gap: 0.8,
                  mt: 1,
                  pt: 1,
                  borderTop: "1px solid #e0e0e0",
                }}
              >
                {/* Edit Button */}
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/dashboard/performaInvoice/${invoice.invoice_number}`, {
                      state: { invoice },
                    });
                  }}
                  sx={{
                    bgcolor: "#e8f5e9",
                    borderRadius: "6px",
                    width: 36,
                    height: 36,
                    "&:hover": { bgcolor: "#c8e6c9" },
                  }}
                >
                  <Edit sx={{ fontSize: "1.1rem", color: "#4caf50" }} />
                </IconButton>

                {/* Delete Button */}
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    setAnchorEl(e.currentTarget);
                    setInvoiceToDelete(invoice.invoice_number);
                  }}
                  sx={{
                    bgcolor: "#ffebee",
                    borderRadius: "6px",
                    width: 36,
                    height: 36,
                    "&:hover": { bgcolor: "#ffcdd2" },
                  }}
                >
                  <DeleteIcon sx={{ fontSize: "1.1rem", color: "#f44336" }} />
                </IconButton>

                {/* Print Button */}
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    printPerforma(invoice);
                  }}
                  sx={{
                    bgcolor: "#fff3e0",
                    borderRadius: "6px",
                    width: 36,
                    height: 36,
                    "&:hover": { bgcolor: "#ffe0b2" },
                  }}
                >
                  <Print sx={{ fontSize: "1.1rem", color: "#ff9800" }} />
                </IconButton>
              </Box>            
              </Box>
          </Box>
        </Collapse>

        <Divider />
      </Box>
    );
  };

  return (
    <>
      <Box sx={{ mt: { xs: 4.1, md: -3 }, pt: -3, mb: 2, width: "100%" }}>
        <ToastContainer position="top-right" autoClose={3000} />

        {/* DESKTOP VIEW */}
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            gap: 2,
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          <TextField
            label="Date Range"
            value={
              filters.date_range === "custom" &&
                customDateRange.from &&
                customDateRange.to
                ? `${formatDateDisplay(
                  customDateRange.from
                )} to ${formatDateDisplay(customDateRange.to)}`
                : filters.date_range === "today"
                  ? "Today"
                  : filters.date_range === "yesterday"
                    ? "Yesterday"
                    : filters.date_range === "this_week"
                      ? "This Week"
                      : filters.date_range === "previous_week"
                        ? "Previous Week"
                        : filters.date_range === "this_month"
                          ? "This Month"
                          : filters.date_range === "current_year"
                            ? "Current Year"
                            : filters.date_range === "financial_year"
                              ? "Financial Year"
                              : "Select Date Range"
            }
            onClick={(e) => setDateMenuAnchor(e.currentTarget)}
            size="small"
            InputProps={{
              readOnly: true,
              endAdornment: (
                <IconButton size="small" edge="end">
                  <ArrowDropDownIcon />
                </IconButton>
              ),
            }}
            sx={{
              flex: "1 1 100px",
              cursor: "pointer",
              "& .MuiInputBase-root": { height: 35, borderRadius: 0 },
              "& .MuiInputLabel-root": { fontSize: "0.65rem" },
            }}
          />

          {/* <Autocomplete
            options={divisionLists || []}
            getOptionLabel={(opt) =>
              opt?.division ? String(opt.division) : ""
            }
            isOptionEqualToValue={(opt, val) =>
              opt.division_id === val?.division_id || opt.division_id === val
            }
            value={
              divisionLists.find(
                (opt) => opt.division_id === filters.division
              ) || null
            }
            onChange={(e, newValue) =>
              setFilters((prev) => ({
                ...prev,
                division: newValue ? newValue.division_id : "",
              }))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Filter by Division"
                variant="outlined"
                size="small"
                sx={{
                  "& .MuiInputBase-root": { height: 35, borderRadius: 0 },
                  "& .MuiInputLabel-root": { fontSize: "0.65rem" },
                }}
              />
            )}
            sx={{ flex: "1 1 100px" }}
          /> */}

          <TextField
            label="Search by Project Name"
            name="project_name"
            value={filters.project_name}
            onChange={handleFilterChange}
            size="small"
            sx={{
              flex: "1 1 100px",
              "& .MuiInputBase-root": { height: 35, borderRadius: 0 },
              "& .MuiInputLabel-root": { fontSize: "0.65rem" },
            }}
          />

          <TextField
            label="PI Date"
            value={
              piDateRange.from && piDateRange.to
                ? `${formatDateDisplay(
                  piDateRange.from
                )} to ${formatDateDisplay(piDateRange.to)}`
                : piDateRange.from
                  ? `From ${formatDateDisplay(piDateRange.from)}`
                  : piDateRange.to
                    ? `To ${formatDateDisplay(piDateRange.to)}`
                    : ""
            }
            placeholder="Select PI Date Range"
            onClick={(e) => {
              setPiDateMenuAnchor(e.currentTarget);
              setTempPiDateRange(piDateRange);
            }}
            size="small"
            InputProps={{
              readOnly: true,
              endAdornment: (
                <IconButton size="small" edge="end">
                  <ArrowDropDownIcon />
                </IconButton>
              ),
            }}
            InputLabelProps={{ shrink: true }}
            sx={{
              flex: "1 1 100px",
              cursor: "pointer",
              "& .MuiInputBase-root": { height: 35, borderRadius: 0 },
              "& .MuiInputLabel-root": { fontSize: "0.65rem" },
              "& .MuiInputBase-input": { cursor: "pointer" },
            }}
          />

          <Menu
            anchorEl={piDateMenuAnchor}
            open={Boolean(piDateMenuAnchor)}
            onClose={handleCancelPiDateRange}
            PaperProps={{ sx: { width: 320, p: 0 } }}
          >
            <Box
              sx={{ px: 2, py: 2, bgcolor: "#fafafa" }}
              onClick={(e) => e.stopPropagation()}
            >
              <Typography
                variant="subtitle2"
                sx={{ mb: 2, fontWeight: 600, color: "#1976d2" }}
              >
                Select PI Date Range
              </Typography>

              <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                <TextField
                  label="From Date"
                  type="date"
                  size="small"
                  fullWidth
                  value={tempPiDateRange.from}
                  onChange={(e) =>
                    setTempPiDateRange((prev) => ({
                      ...prev,
                      from: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    max:
                      tempPiDateRange.to ||
                      new Date().toISOString().split("T")[0],
                  }}
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": { height: 40, fontSize: "0.75rem" },
                    "& .MuiInputLabel-root": { fontSize: "0.75rem" },
                  }}
                />

                <TextField
                  label="To Date"
                  type="date"
                  size="small"
                  fullWidth
                  value={tempPiDateRange.to}
                  onChange={(e) =>
                    setTempPiDateRange((prev) => ({
                      ...prev,
                      to: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    min: tempPiDateRange.from || undefined,
                    max: new Date().toISOString().split("T")[0],
                  }}
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": { height: 40, fontSize: "0.75rem" },
                    "& .MuiInputLabel-root": { fontSize: "0.75rem" },
                  }}
                />
              </Box>

              {tempPiDateRange.from && tempPiDateRange.to && (
                <Typography
                  variant="caption"
                  sx={{
                    display: "block",
                    mb: 2,
                    p: 1,
                    bgcolor: "#e8f5e9",
                    borderRadius: 1,
                    textAlign: "center",
                    color: "#2e7d32",
                    fontWeight: 500,
                  }}
                >
                  📅 {formatDateDisplay(tempPiDateRange.from)} to{" "}
                  {formatDateDisplay(tempPiDateRange.to)}
                </Typography>
              )}

              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  justifyContent: "space-between",
                }}
              >
                <Button
                  variant="text"
                  size="small"
                  color="error"
                  onClick={handleClearPiDateRange}
                  disabled={!piDateRange.from && !piDateRange.to}
                  sx={{ fontSize: "0.7rem", textTransform: "none" }}
                >
                  Clear
                </Button>

                <Box sx={{ display: "flex", gap: 1 }}>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleCancelPiDateRange}
                    sx={{
                      fontSize: "0.7rem",
                      textTransform: "none",
                      borderRadius: 1,
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={handleApplyPiDateRange}
                    disabled={!tempPiDateRange.from || !tempPiDateRange.to}
                    sx={{
                      fontSize: "0.7rem",
                      textTransform: "none",
                      borderRadius: 1,
                    }}
                  >
                    Apply
                  </Button>
                </Box>
              </Box>
            </Box>
          </Menu>

          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleReset}
            sx={{
              height: "35px",
              whiteSpace: "nowrap",
              minWidth: "70px",
              borderRadius: 0,
              fontSize: "0.7rem",
            }}
          >
            Reset
          </Button>

          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate("/dashboard/performaInvoice")}
            startIcon={<AddIcon fontSize="small" />}
            sx={{
              height: 35,
              minWidth: 100,
              fontSize: "0.7rem",
              borderRadius: 0,
              whiteSpace: "nowrap",
            }}
          >
            Proforma Invoice
          </Button>

          <IconButton
            onClick={handleExcelExport}
            disabled={isExcelLoading || proformas.length === 0}
            sx={{
              height: 35,
              width: 35,
              bgcolor: "success.main",
              color: "white",
              borderRadius: 0,
              "&:hover": { bgcolor: "success.dark" },
              "&:disabled": { bgcolor: "grey.400", color: "white" },
            }}
          >
            {isExcelLoading ? (
              <CircularProgress size={18} color="inherit" />
            ) : (
              <FileIcon fontSize="small" />
            )}
          </IconButton>
        </Box>

        {/* MOBILE VIEW */}
        <Box sx={{ display: { xs: "block", md: "none" } }}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)" },
              gap: 1.5,
              mb: 1.5,
            }}
          >
            <TextField
              label="Date Range"
              value={
                filters.date_range === "custom" &&
                  customDateRange.from &&
                  customDateRange.to
                  ? `${formatDateDisplay(
                    customDateRange.from
                  )} to ${formatDateDisplay(customDateRange.to)}`
                  : filters.date_range === "today"
                    ? "Today"
                    : filters.date_range === "yesterday"
                      ? "Yesterday"
                      : filters.date_range === "this_week"
                        ? "This Week"
                        : filters.date_range === "previous_week"
                          ? "Previous Week"
                          : filters.date_range === "this_month"
                            ? "This Month"
                            : filters.date_range === "current_year"
                              ? "Current Year"
                              : filters.date_range === "financial_year"
                                ? "Financial Year"
                                : "Select Date Range"
              }
              onClick={(e) => setDateMenuAnchor(e.currentTarget)}
              size="small"
              fullWidth
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <IconButton size="small" edge="end">
                    <ArrowDropDownIcon />
                  </IconButton>
                ),
              }}
              sx={{ cursor: "pointer", "& .MuiInputBase-root": { height: 40 } }}
            />

            {/* <Autocomplete
              options={divisionLists || []}
              getOptionLabel={(opt) =>
                opt?.division ? String(opt.division) : ""
              }
              isOptionEqualToValue={(opt, val) =>
                opt.division_id === val?.division_id || opt.division_id === val
              }
              value={
                divisionLists.find(
                  (opt) => opt.division_id === filters.division
                ) || null
              }
              onChange={(e, newValue) =>
                setFilters((prev) => ({
                  ...prev,
                  division: newValue ? newValue.division_id : "",
                }))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Filter by Division"
                  variant="outlined"
                  size="small"
                  sx={{ "& .MuiInputBase-root": { height: 40 } }}
                />
              )}
              fullWidth
            /> */}

            <TextField
              label="Search by Project Name"
              name="project_name"
              value={filters.project_name}
              onChange={handleFilterChange}
              size="small"
              fullWidth
              sx={{ "& .MuiInputBase-root": { height: 40 } }}
            />

            <TextField
              label="PI Date"
              value={
                piDateRange.from && piDateRange.to
                  ? `${formatDateDisplay(
                    piDateRange.from
                  )} to ${formatDateDisplay(piDateRange.to)}`
                  : ""
              }
              onClick={(e) => {
                setPiDateMenuAnchor(e.currentTarget);
                setTempPiDateRange(piDateRange);
              }}
              size="small"
              fullWidth
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <IconButton size="small" edge="end">
                    <ArrowDropDownIcon />
                  </IconButton>
                ),
              }}
              InputLabelProps={{ shrink: true }}
              sx={{ cursor: "pointer", "& .MuiInputBase-root": { height: 40 } }}
            />
          </Box>

          <Box
            sx={{ display: "flex", gap: 1, justifyContent: "space-between" }}
          >
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={handleReset}
              fullWidth
              sx={{ height: 40, fontSize: "0.75rem" }}
            >
              Reset
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate("/dashboard/performaInvoice")}
              startIcon={<AddIcon fontSize="small" />}
              fullWidth
              sx={{ height: 40, fontSize: "0.75rem" }}
            >
              Add PI
            </Button>
          </Box>
        </Box>

        {/* Date Range Menu */}
        <Menu
          anchorEl={dateMenuAnchor}
          open={Boolean(dateMenuAnchor)}
          onClose={() => {
            setDateMenuAnchor(null);
            setShowCustomDateInputs(false);
            setTempCustomDateRange({ from: "", to: "" });
          }}
          PaperProps={{
            sx: {
              width: 350,
              maxHeight: 500,
              "& .MuiTypography-root": { fontSize: "0.7rem" },
            },
          }}
        >
          {[
            { key: "today", label: "Today" },
            { key: "yesterday", label: "Yesterday" },
            { key: "this_week", label: "This Week" },
            { key: "previous_week", label: "Previous Week" },
            { key: "this_month", label: "This Month" },
            { key: "current_year", label: "Current Year" },
            { key: "financial_year", label: "Financial Year" },
          ].map((range) => (
            <MenuItem
              key={range.key}
              onClick={() => {
                setFilters((prev) => ({ ...prev, date_range: range.key }));
                setCustomDateRange({ from: "", to: "" });
                setDateMenuAnchor(null);
                setShowCustomDateInputs(false);
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Typography variant="body2">{range.label}</Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontSize: "0.65rem" }}
                >
                  {getDateRangeDisplay(range.key)}
                </Typography>
              </Box>
            </MenuItem>
          ))}

          <Divider />

          <MenuItem
            onClick={() => setShowCustomDateInputs(!showCustomDateInputs)}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              bgcolor: showCustomDateInputs ? "#e3f2fd" : "inherit",
            }}
          >
            <Typography
              variant="body2"
              sx={{ fontWeight: showCustomDateInputs ? 600 : 400 }}
            >
              Custom Date Range
            </Typography>
            {showCustomDateInputs ? <ExpandLess /> : <ExpandMore />}
          </MenuItem>

          <Collapse in={showCustomDateInputs} timeout="auto" unmountOnExit>
            <Box
              sx={{
                px: 2,
                py: 2,
                bgcolor: "#f5f5f5",
                borderTop: "1px solid #e0e0e0",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ mb: 1, display: "block" }}
              >
                Select Date Range
              </Typography>

              <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                <TextField
                  label="From Date"
                  type="date"
                  size="small"
                  value={tempCustomDateRange.from}
                  onChange={(e) =>
                    setTempCustomDateRange((prev) => ({
                      ...prev,
                      from: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    max:
                      tempCustomDateRange.to ||
                      new Date().toISOString().split("T")[0],
                  }}
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": { height: 40, fontSize: "0.75rem" },
                    "& .MuiInputLabel-root": { fontSize: "0.75rem" },
                  }}
                />

                <TextField
                  label="To Date"
                  type="date"
                  size="small"
                  value={tempCustomDateRange.to}
                  onChange={(e) =>
                    setTempCustomDateRange((prev) => ({
                      ...prev,
                      to: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    min: tempCustomDateRange.from || undefined,
                    max: new Date().toISOString().split("T")[0],
                  }}
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": { height: 40, fontSize: "0.75rem" },
                    "& .MuiInputLabel-root": { fontSize: "0.75rem" },
                  }}
                />
              </Box>

              {tempCustomDateRange.from && tempCustomDateRange.to && (
                <Typography
                  variant="caption"
                  sx={{
                    display: "block",
                    mb: 1.5,
                    p: 1,
                    bgcolor: "#e8f5e9",
                    borderRadius: 1,
                    textAlign: "center",
                    color: "#2e7d32",
                    fontWeight: 500,
                  }}
                >
                  📅 {formatDateDisplay(tempCustomDateRange.from)} to{" "}
                  {formatDateDisplay(tempCustomDateRange.to)}
                </Typography>
              )}

              <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCancelCustomDateRange}
                  sx={{
                    fontSize: "0.7rem",
                    textTransform: "none",
                    borderRadius: 1,
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleApplyCustomDateRange}
                  disabled={
                    !tempCustomDateRange.from || !tempCustomDateRange.to
                  }
                  sx={{
                    fontSize: "0.7rem",
                    textTransform: "none",
                    borderRadius: 1,
                  }}
                >
                  Apply
                </Button>
              </Box>
            </Box>
          </Collapse>
        </Menu>
      </Box>

      <Box sx={{ position: "relative", flex: 1, minHeight: "400px" }}>

        {/* ✅ LOADING OVERLAY - Only shows for filter changes */}
        {filterLoading && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              zIndex: 1000,
              borderRadius: 1,
            }}
          >
            <CircularProgress size={50} thickness={4} color="primary" />
            <Typography sx={{ mt: 2, color: "#333", fontWeight: 500 }}>
              {filters.date_range === "financial_year"
                ? "Loading Financial Year Data..."
                : filters.date_range === "current_year"
                  ? "Loading Current Year Data..."
                  : filters.date_range === "this_month"
                    ? "Loading This Month Data..."
                    : filters.date_range === "this_week"
                      ? "Loading This Week Data..."
                      : filters.date_range === "previous_week"
                        ? "Loading Previous Week Data..."
                        : filters.date_range === "custom"
                          ? "Loading Custom Date Range..."
                          : filters.po_date_from && filters.po_date_to
                            ? "Loading PO Date Range..."
                            : "Loading Data..."}
            </Typography>
            <Typography sx={{ mt: 0.5, color: "#666", fontSize: "0.8rem" }}>
              Please wait, this may take a moment
            </Typography>
          </Box>
        )}

        <InfiniteScroll
          dataLength={proformas.length}
          next={fetchMoreData}
          hasMore={hasMore}
          height="86vh"
          loader={
            <Typography textAlign="center" p={2}>
              Loading...
            </Typography>
          }
          endMessage={
            <Typography textAlign="center" p={2}>
              No more records!
            </Typography>
          }
        >
          {isMobile ? (
            <Box sx={{ bgcolor: "background.paper" }}>
              {Array.isArray(proformas) && proformas.length > 0 ? (
                proformas.map((invoice, index) => (
                  <MobileProformaCard
                    key={invoice.invoice_number}
                    invoice={invoice}
                    index={index}
                  />
                ))
              ) : (
                <Typography textAlign="center" p={4}>
                  No proforma invoices found
                </Typography>
              )}
            </Box>
          ) : (
            <TableContainer
              component={Paper}
              sx={{ overflowX: "auto" }}
            >
              <Table
                stickyHeader
                size="small"
                sx={{
                  minWidth: "max-content",
                  "& td, & th": {
                    borderBottom: "1px solid #ccc",
                    whiteSpace: "nowrap",
                  },
                }}
              >
                <TableHead
                  sx={{
                    "& th": {
                      fontWeight: "bold",
                      color: (theme) =>
                        theme.palette.mode === "dark" ? "#2196f3" : "#333",
                      backgroundColor: (theme) =>
                        theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                    },
                  }}
                >
                  <TableRow
                    sx={{
                      backgroundColor: "#f5f5f5",
                      "& th": {
                        fontWeight: "bold",
                        color: "#333",
                        borderBottom: "1px solid #999",
                        whiteSpace: "nowrap",
                      },
                    }}
                  >
                    {/* {userRole != "Staff" && (
                      <TableCell align="center">Approve</TableCell>
                    )} */}
                    <TableCell align="center">S.No.</TableCell>
                    <TableCell
                      sx={{
                        position: "sticky",
                        left: 0,
                        background: "#fff",
                        zIndex: 3,
                      }}
                      align="center"
                    >
                      PI No.
                    </TableCell>
                    <TableCell align="center">PI Date</TableCell>
                    <TableCell align="center">Status</TableCell>
                    <TableCell align="center">Debtor</TableCell>
                    {/* <TableCell align="center">Division</TableCell> */}
                    <TableCell align="center">PI Amt</TableCell>
                    {/* <TableCell align="center">Rec Amt</TableCell> */}
                    <TableCell align="center">Project</TableCell>
                    <TableCell align="center">Created By</TableCell>
                    {/* <TableCell align="center">Approved By</TableCell> */}
                    <TableCell align="center">Date</TableCell>
                    {/* <TableCell>Remarks</TableCell> */}
                    <TableCell
                      align="center"
                      sx={{
                        position: "sticky",
                        right: 0,
                        backgroundColor: "#fff",
                        zIndex: 3,
                      }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.isArray(proformas) && proformas.length > 0 ? (
                    proformas.map((invoice, idx) => (
                      <TableRow
                        key={invoice.invoice_number}
                        hover
                        sx={{
                          backgroundColor: idx % 2 === 0 ? "#fafafa" : "#ffffff",
                          "&:hover": {
                            backgroundColor: "#e3f2fd !important",
                          },
                          "& td": {
                            paddingTop: "2px !important",
                            paddingBottom: "2px !important",
                            fontSize: { xs: "0.75rem", sm: "0.8125rem" },
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            color: (theme) =>
                              theme.palette.mode === "dark" ? "white" : "inherit",
                            backgroundColor: (theme) =>
                              theme.palette.mode === "dark" ? "black" : "inherit",
                          },
                        }}
                      >
                        {/* {userRole != "Staff" && (
                          <TableCell align="center">
                            <IconButton
                              size="small"
                              onClick={() => {
                                setPIToApprove(invoice);
                                setApprovalDialogOpen(true);
                              }}
                              sx={{ padding: 0 }}
                            >
                              <Visibility sx={{ fontSize: "1rem", color: "#1976d2" }} />
                            </IconButton>
                          </TableCell>
                        )} */}

                        <TableCell align="center">{idx + 1}</TableCell>

                        <TableCell
                          sx={{
                            position: "sticky",
                            left: 0,
                            background: "#f9f9f9",
                            zIndex: 1,
                          }}
                          align="center"
                        >
                          {invoice.pi_no || "N/A"}
                        </TableCell>
                        <TableCell align="center">
                          {invoice.pi_date
                            ? new Date(
                              invoice.pi_date + "T00:00:00"
                            ).toLocaleDateString("en-GB")
                            : "N/A"}
                        </TableCell>
                        <TableCell align="center">
                          <Chip
                            label={
                              invoice.status === "Approved"
                                ? "Approved"
                                : invoice.status === "Rejected"
                                  ? "Rejected"
                                  : "Pending"
                            }
                            color={
                              invoice.status === "Approved"
                                ? "success"
                                : invoice.status === "Rejected"
                                  ? "error"
                                  : "warning"
                            }
                            variant="outlined"
                            size="small"
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Tooltip
                            title={
                              invoice.project?.party_details?.company_name || "-"
                            }
                            arrow
                          >
                            <span>
                              {truncateText(
                                invoice.project?.party_details?.company_name ||
                                "-",
                                20
                              )}
                            </span>
                          </Tooltip>
                        </TableCell>
                        {/* <TableCell align="center">
                        {invoice.project?.division_name || "-"}
                      </TableCell> */}
                        <TableCell align="center">
                          {Number(invoice.advance_received || 0).toLocaleString(
                            "en-IN",
                            {
                              minimumFractionDigits: 1,
                              maximumFractionDigits: 1,
                            }
                          )}
                        </TableCell>
                        {/* <TableCell align="center">
                        {Number(invoice.receive_amt || 0).toLocaleString(
                          "en-IN",
                          {
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                          }
                        )}
                      </TableCell> */}

                        <TableCell align="center">
                          <Tooltip
                            title={invoice.project?.project_name || "-"}
                            arrow
                          >
                            <span>
                              {truncateText(
                                invoice.project?.project_name || "-",
                                20
                              )}
                            </span>
                          </Tooltip>
                        </TableCell>

                        <TableCell align="center">
                          {invoice.created_by_po || "-"}
                        </TableCell>
                        {/* <TableCell align="center">
                          {invoice.approved_name || "-"}
                        </TableCell> */}
                        <TableCell align="center">
                          {formatOnlyDate(invoice.created_at)}
                        </TableCell>
                        {/* <TableCell>
                          <Tooltip title={invoice.remarks || ""} arrow>
                            <span>{truncateText(invoice.remarks, 20)}</span>
                          </Tooltip>
                        </TableCell> */}
                        <TableCell
                          sx={{
                            position: "sticky",
                            right: 0,
                            backgroundColor: "#f9f9f9",
                            zIndex: 1,
                          }}
                          align="center"
                        >
                          <IconButton
                            sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                            size="small"
                            onClick={() =>
                              navigate(
                                `/dashboard/performaInvoice/${invoice.invoice_number}`,
                                {
                                  state: { invoice },
                                }
                              )
                            }
                            // disabled={invoice.status === "Approved"}
                            color="primary"
                          >
                            <Edit fontSize="small" />
                          </IconButton>
                          <IconButton
                            sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                            size="small"
                            color="error"
                            onClick={(e) => {
                              setAnchorEl(e.currentTarget);
                              setInvoiceToDelete(invoice.invoice_number);
                            }}
                          // disabled={invoice.status === "Approved"}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                            sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                            size="small"
                            onClick={() => printPerforma(invoice)}
                          >
                            <Print fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={15} align="center">
                        <Typography p={1}>No proforma invoices found</Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </InfiniteScroll>
      </Box>

      {/* Delete Confirmation Menu */}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Box sx={{ p: 2, width: 220 }}>
          <Typography sx={{ mb: 1 }}>
            Are you sure you want to delete?
          </Typography>

          <Box
            sx={{ display: "flex", justifyContent: "space-between", gap: 1 }}
          >
            <Button size="small" onClick={() => setAnchorEl(null)}>
              Cancel
            </Button>

            <Button
              size="small"
              color="error"
              onClick={() => {
                handleDelete(invoiceToDelete);
                setAnchorEl(null);
              }}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Popover>

      {/* Approval Dialog */}
      {/* Approval Dialog - IMPROVED VERSION */}
      <Dialog
        open={approvalDialogOpen}
        onClose={() => {
          setApprovalDialogOpen(false);
          setRemarkInput("");
          setPIToApprove(null);
        }}
        maxWidth="lg"
        fullWidth
        fullScreen={isMobile}
        scroll="paper"
        PaperProps={{
          sx: {
            minHeight: isMobile ? "100vh" : "80vh",
            maxHeight: isMobile ? "100vh" : "90vh",
            m: isMobile ? 0 : 2,
            borderRadius: isMobile ? 0 : 2,
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pb: 1,
            px: isMobile ? 1.5 : 3,
            pt: isMobile ? 1.5 : 2,
            borderBottom: "1px solid #e0e0e0",
            position: "sticky",
            top: 0,
            bgcolor: "white",
            zIndex: 10,
          }}
        >
          <Typography
            variant={isMobile ? "subtitle1" : "h6"}
            sx={{
              fontSize: isMobile ? "0.95rem" : "1.25rem",
              fontWeight: 600,
            }}
          >
            Review Proforma Invoice
          </Typography>
          <IconButton
            onClick={() => {
              setApprovalDialogOpen(false);
              setRemarkInput("");
              setPIToApprove(null);
            }}
            size={isMobile ? "small" : "medium"}
            sx={{
              bgcolor: "#f5f5f5",
              "&:hover": { bgcolor: "#e0e0e0" },
            }}
          >
            <CloseIcon sx={{ fontSize: isMobile ? "1.2rem" : "1.5rem" }} />
          </IconButton>
        </DialogTitle>

        <DialogContent
          dividers
          sx={{
            p: isMobile ? 0.5 : 2,
            bgcolor: "#f9f9f9",
            overflowX: "hidden",
          }}
        >
          {piToApprove && (
            <Box
              sx={{
                width: "100%",
                border: "1px solid #000",
                bgcolor: "white",
                mx: "auto",
              }}
            >
              {/* Header - Red Title */}
              <Box
                sx={{
                  color: "red",
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: isMobile ? "12px" : "18px",
                  p: isMobile ? 0.5 : 1.5,
                  border: "1px solid #000",
                  borderBottom: "none",
                }}
              >
                PROFORMA INVOICE
              </Box>

              {/* MOBILE OPTIMIZED LAYOUT */}
              {isMobile ? (
                <Box sx={{ border: "1px solid #000", borderTop: "none" }}>
                  {/* Compact Header Section - Mobile */}
                  <Box
                    sx={{
                      borderBottom: "1px solid #000",
                      p: 0.8,
                      bgcolor: "#f9f9f9",
                    }}
                  >
                    <Grid container spacing={0.5}>
                      {/* Left Column */}
                      <Grid item xs={6}>
                        <Typography sx={{ fontSize: "0.5rem", color: "#666" }}>
                          PI No:
                        </Typography>
                        <Typography
                          sx={{ fontSize: "0.6rem", fontWeight: 600, mb: 0.3 }}
                        >
                          {piToApprove.pi_no || "N/A"}
                        </Typography>

                        <Typography sx={{ fontSize: "0.5rem", color: "#666" }}>
                          PI Date:
                        </Typography>
                        <Typography
                          sx={{ fontSize: "0.6rem", fontWeight: 600, mb: 0.3 }}
                        >
                          {formatOnlyDate(piToApprove.pi_date)}
                        </Typography>

                        <Typography sx={{ fontSize: "0.5rem", color: "#666" }}>
                          S.O. No:
                        </Typography>
                        <Typography
                          sx={{ fontSize: "0.6rem", fontWeight: 600 }}
                        >
                          {piToApprove.project?.so_no || "N/A"}
                        </Typography>
                      </Grid>

                      {/* Right Column */}
                      <Grid item xs={6}>
                        <Typography sx={{ fontSize: "0.5rem", color: "#666" }}>
                          P.O. No:
                        </Typography>
                        <Typography
                          sx={{ fontSize: "0.6rem", fontWeight: 600, mb: 0.3 }}
                        >
                          {piToApprove.project?.po_number || "-"}
                        </Typography>

                        <Typography sx={{ fontSize: "0.5rem", color: "#666" }}>
                          P.O. Date:
                        </Typography>
                        <Typography
                          sx={{ fontSize: "0.6rem", fontWeight: 600, mb: 0.3 }}
                        >
                          {formatOnlyDate(piToApprove.project?.order_date)}
                        </Typography>

                        <Typography sx={{ fontSize: "0.5rem", color: "#666" }}>
                          Created:
                        </Typography>
                        <Typography
                          sx={{ fontSize: "0.6rem", fontWeight: 600 }}
                        >
                          {formatOnlyDate(piToApprove.created_at)}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>

                  {/* Seller - Compact Mobile */}
                  <Box sx={{ borderBottom: "1px solid #000", p: 0.8 }}>
                    <Box
                      sx={{
                        display: "flex",
                        gap: 0.8,
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{ width: "70px", height: "70px", flexShrink: 0 }}
                      >
                        <img
                          src={"/logoblack.png"}
                          alt="Logo"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                          }}
                        />
                      </Box>
                      <Box sx={{ flex: 1 }}>
                        <Typography
                          sx={{
                            fontWeight: "bold",
                            fontSize: "0.6rem",
                            lineHeight: 1.2,
                          }}
                        >
                          CRANOIST MHE PVT. LTD.
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.5rem",
                            lineHeight: 1.2,
                            color: "#666",
                          }}
                        >
                          Plot No.37, Phase-II, Siltara, Raipur (C.G.), 493111
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.5rem",
                            lineHeight: 1.2,
                            color: "#666",
                          }}
                        >
                          📞 8224086999, 9825586999
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.5rem",

                            color: "blue",
                            lineHeight: 1.2,
                          }}
                        >
                          ✉ info@cranoistmhe.com
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  {/* Buyer & Billing - Compact Side by Side */}
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    {/* Buyer */}
                    <Box sx={{ p: 0.8, borderRight: "1px solid #000" }}>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: "0.55rem",
                          mb: 0.3,
                          color: "#1976d2",
                        }}
                      >
                        BUYER
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: "0.55rem",
                          mb: 0.2,
                        }}
                      >
                        {piToApprove.project?.party_details?.company_name ||
                          "N/A"}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.5rem",
                          lineHeight: 1.2,
                          color: "#666",
                        }}
                      >
                        GST: {piToApprove.project?.party_details?.gst || "N/A"}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.5rem",
                          lineHeight: 1.2,
                          color: "#666",
                        }}
                      >
                        State:{" "}
                        {piToApprove.project?.party_details?.state || "22"}
                      </Typography>
                    </Box>

                    {/* Billing Address */}
                    <Box sx={{ p: 0.8 }}>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: "0.55rem",
                          mb: 0.3,
                          color: "#1976d2",
                        }}
                      >
                        BILLING ADDR
                      </Typography>
                      <Typography
                        sx={{ fontSize: "0.5rem", lineHeight: 1.2, mb: 0.2 }}
                      >
                        {piToApprove.project?.party_details?.address?.substring(
                          0,
                          60
                        ) || "Same as Buyer"}
                        {piToApprove.project?.party_details?.address?.length >
                          60 && "..."}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Tax & Payment Terms - Compact Side by Side */}
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Box sx={{ p: 0.8, borderRight: "1px solid #000" }}>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: "0.55rem",
                          mb: 0.3,
                          color: "#1976d2",
                        }}
                      >
                        TAX TERMS
                      </Typography>
                      {Array.isArray(piToApprove.tax_terms) &&
                        piToApprove.tax_terms.length > 0 ? (
                        piToApprove.tax_terms
                          .slice(0, 2)
                          .map((taxTerm, index) => (
                            <Typography
                              key={index}
                              sx={{
                                fontSize: "0.5rem",
                                lineHeight: 1.2,
                                mb: 0.1,
                              }}
                            >
                              {index + 1}){" "}
                              {taxTerm.term?.substring(0, 35) || "N/A"}
                              {taxTerm.term?.length > 35 && "..."}
                            </Typography>
                          ))
                      ) : (
                        <>
                          <Typography
                            sx={{
                              fontSize: "0.5rem",
                              lineHeight: 1.2,
                              mb: 0.1,
                            }}
                          >
                            1) GST {piToApprove.gst_percent || "0"}% Extra
                          </Typography>
                          <Typography
                            sx={{ fontSize: "0.5rem", lineHeight: 1.2 }}
                          >
                            2) Freight F.O.R. Site
                          </Typography>
                        </>
                      )}
                    </Box>

                    <Box sx={{ p: 0.8 }}>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: "0.55rem",
                          mb: 0.3,
                          color: "#1976d2",
                        }}
                      >
                        PAYMENT TERMS
                      </Typography>
                      {Array.isArray(piToApprove.payment_terms) &&
                        piToApprove.payment_terms.length > 0 ? (
                        piToApprove.payment_terms
                          .slice(0, 2)
                          .map((paymentTerm, index) => (
                            <Typography
                              key={index}
                              sx={{
                                fontSize: "0.5rem",
                                lineHeight: 1.2,
                                mb: 0.1,
                              }}
                            >
                              {index + 1}){" "}
                              {paymentTerm.term?.substring(0, 35) || "N/A"}
                              {paymentTerm.term?.length > 35 && "..."}
                            </Typography>
                          ))
                      ) : (
                        <Typography
                          sx={{ fontSize: "0.5rem", lineHeight: 1.2 }}
                        >
                          1) 50% adv, bal on delivery
                        </Typography>
                      )}
                    </Box>
                  </Box>

                  {/* Items Table - Mobile Card View */}
                  <Box sx={{ borderBottom: "1px solid #000" }}>
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        textAlign: "center",
                        fontSize: "0.65rem",
                        p: 0.8,
                        bgcolor: "#f5f5f5",
                        borderBottom: "1px solid #000",
                      }}
                    >
                      ITEMS DETAILS
                    </Typography>

                    {Array.isArray(piToApprove.project?.items) &&
                      piToApprove.project.items.length > 0 ? (
                      piToApprove.project.items.map((item, i) => (
                        <Box
                          key={i}
                          sx={{
                            p: 1,
                            borderBottom:
                              i < piToApprove.project.items.length - 1
                                ? "1px solid #ddd"
                                : "none",
                            bgcolor: i % 2 === 0 ? "#fafafa" : "#fff",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: "bold",
                              fontSize: "0.6rem",
                              mb: 0.5,
                              color: "#1976d2",
                            }}
                          >
                            {i + 1}.{" "}
                            {item.item_name || item.description || "N/A"}
                          </Typography>

                          {item.description &&
                            item.item_name !== item.description && (
                              <Typography
                                sx={{
                                  fontSize: "0.55rem",
                                  color: "#666",
                                  mb: 0.5,
                                  fontStyle: "italic",
                                }}
                              >
                                {item.description}
                              </Typography>
                            )}

                          <Box
                            sx={{
                              display: "grid",
                              gridTemplateColumns: "1fr 1fr",
                              gap: 0.5,
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                borderBottom: "1px solid #f0f0f0",
                                pb: 0.3,
                              }}
                            >
                              <Typography
                                sx={{ fontSize: "0.55rem", color: "#666" }}
                              >
                                UOM:
                              </Typography>
                              <Typography
                                sx={{ fontSize: "0.55rem", fontWeight: 500 }}
                              >
                                {item.uom || "Nos"}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                borderBottom: "1px solid #f0f0f0",
                                pb: 0.3,
                              }}
                            >
                              <Typography
                                sx={{ fontSize: "0.55rem", color: "#666" }}
                              >
                                Qty:
                              </Typography>
                              <Typography
                                sx={{ fontSize: "0.55rem", fontWeight: 500 }}
                              >
                                {Number(
                                  item.pi_qty || item.quantity || 0
                                ).toFixed(2)}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                borderBottom: "1px solid #f0f0f0",
                                pb: 0.3,
                              }}
                            >
                              <Typography
                                sx={{ fontSize: "0.55rem", color: "#666" }}
                              >
                                Rate:
                              </Typography>
                              <Typography
                                sx={{ fontSize: "0.55rem", fontWeight: 500 }}
                              >
                                ₹
                                {Number(item.rate || 0).toLocaleString(
                                  "en-IN",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                pb: 0.3,
                              }}
                            >
                              <Typography
                                sx={{ fontSize: "0.55rem", color: "#666" }}
                              >
                                Amount:
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: "0.55rem",
                                  fontWeight: 600,
                                  color: "#2e7d32",
                                }}
                              >
                                ₹
                                {Number(item.amount || 0).toLocaleString(
                                  "en-IN",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      ))
                    ) : (
                      <Box sx={{ p: 1, bgcolor: "#fafafa" }}>
                        <Typography
                          sx={{
                            fontWeight: "bold",
                            fontSize: "0.6rem",
                            mb: 0.5,
                          }}
                        >
                          {piToApprove.remarks ||
                            `Advance for ${piToApprove.project?.project_name || "N/A"
                            }`}
                        </Typography>
                        <Box
                          sx={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: 0.5,
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography
                              sx={{ fontSize: "0.55rem", color: "#666" }}
                            >
                              UOM:
                            </Typography>
                            <Typography
                              sx={{ fontSize: "0.55rem", fontWeight: 500 }}
                            >
                              LS
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography
                              sx={{ fontSize: "0.55rem", color: "#666" }}
                            >
                              Qty:
                            </Typography>
                            <Typography
                              sx={{ fontSize: "0.55rem", fontWeight: 500 }}
                            >
                              1
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography
                              sx={{ fontSize: "0.55rem", color: "#666" }}
                            >
                              Rate:
                            </Typography>
                            <Typography
                              sx={{ fontSize: "0.55rem", fontWeight: 500 }}
                            >
                              ₹
                              {Number(
                                piToApprove.basic_value || 0
                              ).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography
                              sx={{ fontSize: "0.55rem", color: "#666" }}
                            >
                              Amount:
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "0.55rem",
                                fontWeight: 600,
                                color: "#2e7d32",
                              }}
                            >
                              ₹
                              {Number(
                                piToApprove.basic_value || 0
                              ).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    )}
                  </Box>

                  {/* Summary - Mobile */}
                  <Box sx={{ borderBottom: "1px solid #000" }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        p: 0.8,
                        bgcolor: "#f5f5f5",
                        borderBottom: "1px solid #000",
                      }}
                    >
                      <Typography
                        sx={{ fontSize: "0.6rem", fontWeight: "bold" }}
                      >
                        BASIC VALUE
                      </Typography>
                      <Typography
                        sx={{ fontSize: "0.6rem", fontWeight: "bold" }}
                      >
                        ₹
                        {Number(piToApprove.basic_value || 0).toLocaleString(
                          "en-IN",
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        )}
                      </Typography>
                    </Box>

                    {piToApprove.gst_amount > 0 && (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          p: 0.8,
                          borderBottom: "1px solid #ddd",
                        }}
                      >
                        <Typography sx={{ fontSize: "0.6rem" }}>
                          GST @ {piToApprove.gst_percent || 0}%
                        </Typography>
                        <Typography sx={{ fontSize: "0.6rem" }}>
                          ₹
                          {Number(piToApprove.gst_amount || 0).toLocaleString(
                            "en-IN",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                        </Typography>
                      </Box>
                    )}

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        p: 0.8,
                        bgcolor: "#e3f2fd",
                      }}
                    >
                      <Typography
                        sx={{ fontSize: "0.6rem", fontWeight: "bold" }}
                      >
                        PAYABLE AS ADV @ {piToApprove.advance_percent || 0}%
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.6rem",
                          fontWeight: "bold",
                          color: "#2e7d32",
                        }}
                      >
                        ₹
                        {Number(
                          piToApprove.advance_received || 0
                        ).toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Amount in Words - Mobile */}
                  <Box sx={{ p: 0.8, borderBottom: "1px solid #000" }}>
                    <Typography
                      sx={{ fontWeight: "bold", fontSize: "0.6rem", mb: 0.2 }}
                    >
                      In Words:
                    </Typography>
                    <Typography
                      sx={{ fontSize: "0.55rem", fontStyle: "italic" }}
                    >
                      {piToApprove.amount_in_words || "N/A"}
                    </Typography>
                  </Box>

                  {/* Terms & Conditions - Mobile */}
                  <Box sx={{ p: 0.8, borderBottom: "1px solid #000" }}>
                    <Typography
                      sx={{ fontWeight: "bold", fontSize: "0.6rem", mb: 0.3 }}
                    >
                      Terms & Conditions:
                    </Typography>
                    {Array.isArray(piToApprove.project?.terms_and_conditions) &&
                      piToApprove.project.terms_and_conditions.length > 0 ? (
                      piToApprove.project.terms_and_conditions
                        .filter(
                          (tc) =>
                            tc.key === "Jurisdiction" ||
                            tc.key === "Rejection/Claim" ||
                            tc.key === "Remark"
                        )
                        .map((tc, index) => (
                          <Typography
                            key={index}
                            sx={{
                              fontSize: "0.55rem",
                              lineHeight: 1.3,
                              mb: 0.2,
                            }}
                          >
                            {index + 1}. {tc.key}: {tc.value}
                          </Typography>
                        ))
                    ) : (
                      <>
                        <Typography
                          sx={{ fontSize: "0.55rem", lineHeight: 1.3, mb: 0.2 }}
                        >
                          1. Dispute subject to Durg Jurisdiction
                        </Typography>
                        <Typography
                          sx={{ fontSize: "0.55rem", lineHeight: 1.3 }}
                        >
                          2. Interest @22% p.a. after 7 days
                        </Typography>
                      </>
                    )}
                  </Box>

                  {/* Bank Details - Mobile */}
                  <Box sx={{ p: 0.8, borderBottom: "1px solid #000" }}>
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        fontSize: "0.6rem",
                        mb: 0.3,
                        textDecoration: "underline",
                      }}
                    >
                      Bank Transfer Details:
                    </Typography>
                    {piToApprove.bank_details ? (
                      <>
                        <Typography
                          sx={{ fontSize: "0.55rem", lineHeight: 1.3 }}
                        >
                          <strong>A/C:</strong>{" "}
                          {piToApprove.bank_details.account_number || "N/A"}
                        </Typography>
                        <Typography
                          sx={{ fontSize: "0.55rem", lineHeight: 1.3 }}
                        >
                          <strong>Bank:</strong>{" "}
                          {piToApprove.bank_details.bank_name || "N/A"}
                        </Typography>
                        <Typography
                          sx={{ fontSize: "0.55rem", lineHeight: 1.3 }}
                        >
                          <strong>IFSC:</strong>{" "}
                          {piToApprove.bank_details.ifsc_code || "N/A"}
                        </Typography>
                      </>
                    ) : (
                      <>
                        <Typography
                          sx={{ fontSize: "0.55rem", lineHeight: 1.3 }}
                        >
                          <strong>A/C:</strong> 22222563453
                        </Typography>
                        <Typography
                          sx={{ fontSize: "0.55rem", lineHeight: 1.3 }}
                        >
                          <strong>Bank:</strong> HDFC, Sun and Suns
                        </Typography>
                        <Typography
                          sx={{ fontSize: "0.55rem", lineHeight: 1.3 }}
                        >
                          <strong>IFSC:</strong> AAAA0001ABC
                        </Typography>
                      </>
                    )}
                  </Box>

                  {/* GST Info & Authorization - Mobile */}
                  <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
                    <Box sx={{ p: 0.8, borderRight: "1px solid #000" }}>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: "0.6rem",
                          mb: 0.3,
                          textAlign: "center",
                        }}
                      >
                        GST INFO
                      </Typography>
                      <Typography sx={{ fontSize: "0.55rem", lineHeight: 1.3 }}>
                        GSTIN: {divisionLocalStorage?.gst_no || "22AAHFK2314C1Z4"}
                      </Typography>
                      <Typography sx={{ fontSize: "0.55rem", lineHeight: 1.3 }}>
                        PAN: {divisionLocalStorage?.pan_no || "AAHFK2314C1"}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        p: 0.8,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{ fontWeight: "bold", fontSize: "0.6rem", mb: 1 }}
                      >
                        AUTHORIZATION
                      </Typography>
                      <Typography sx={{ fontSize: "0.55rem" }}>
                        For CRANOIST MHE PVT. LTD.
                      </Typography>
                      <Typography sx={{ fontSize: "0.55rem", mt: 1.5 }}>
                        (Signature)
                      </Typography>
                      <Typography sx={{ fontSize: "0.55rem" }}>
                        Auth. Signatory
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              ) : (
                /* DESKTOP LAYOUT - WITH FIXED ITEMS TABLE */
                <Box>
                  <table style={styles.table}>
                    <tbody>
                      <tr>
                        <td style={{ ...styles.cell, width: "50%" }}>
                          <div style={{ ...styles.bold, textAlign: "center" }}>
                            SELLER
                          </div>
                          <Box sx={{ mt: 1 }}>
                            <div
                              style={{
                                float: "left",
                                width: "100px",
                                height: "100px",
                              }}
                            >
                              <img
                                src={"/logoblack.png"}
                                alt="Company Logo"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "contain",
                                }}
                              />
                            </div>
                            <div
                              style={{
                                fontWeight: "bold",
                                textAlign: "center",
                              }}
                            >
                              CRANOIST MHE PVT. LTD.
                            </div>
                            <div style={{ textAlign: "center" }}>
                              Works: Plot No.37, Phase-II, Siltara Ind. Area,
                            </div>
                            <div style={{ textAlign: "center" }}>
                              Rashmada Bhilai RAipur (c.g)
                            </div>
                            <div style={{ textAlign: "center" }}>
                              Contact: 8224086999, 9825586999
                            </div>
                            <div style={{ color: "blue", textAlign: "center" }}>
                              E-mail: info@cranoistmhe.com
                            </div>
                          </Box>
                        </td>
                        <td
                          style={{
                            ...styles.cell,
                            width: "25%",
                            textAlign: "center",
                          }}
                        >
                          <div style={styles.bold}>No & Date</div>
                          <div style={{ marginTop: "10px" }}>
                            PI No: {piToApprove.pi_no || "N/A"}
                          </div>
                          <div style={{ marginTop: "5px" }}>
                            PI Date: {formatOnlyDate(piToApprove.pi_date)}
                          </div>
                          <div style={{ marginTop: "5px" }}>
                            Created Date:{" "}
                            {formatOnlyDate(piToApprove.created_at)}
                          </div>
                          <div style={{ marginTop: "5px" }}>
                            S.O. No: {piToApprove.project?.so_no || "N/A"}
                          </div>
                        </td>
                        <td
                          style={{
                            ...styles.cell,
                            width: "25%",
                            textAlign: "center",
                          }}
                        >
                          <div style={styles.bold}>Buyer's Order No & Date</div>
                          <div style={{ marginTop: "10px" }}>
                            P.O. No: {piToApprove.project?.po_number || "-"}
                          </div>
                          <div style={{ marginTop: "10px" }}>
                            P.O. Date:{" "}
                            {formatOnlyDate(piToApprove.project?.order_date)}
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td
                          style={{ ...styles.headerCell, textAlign: "center" }}
                        >
                          BUYER
                        </td>
                        <td
                          style={{ ...styles.headerCell, textAlign: "center" }}
                          colSpan={2}
                        >
                          BILLING ADDRESS
                        </td>
                      </tr>

                      <tr>
                        <td style={styles.cell}>
                          <div style={styles.bold}>
                            {piToApprove.project?.party_details?.company_name ||
                              "N/A"}
                          </div>
                          <div>
                            GSTIN:{" "}
                            {piToApprove.project?.party_details?.gst || "N/A"}
                          </div>
                          <div>
                            STATE CODE:{" "}
                            {piToApprove.project?.party_details?.state || "22"}
                          </div>
                          <div>
                            Address:{" "}
                            {piToApprove.project?.party_details?.address ||
                              "N/A"}
                          </div>
                        </td>
                        <td style={styles.cell} colSpan={2}>
                          <div style={styles.bold}>
                            {piToApprove.project?.party_details?.company_name ||
                              "N/A"}
                          </div>
                          <div>
                            {piToApprove.shipping_address ||
                              piToApprove.project?.party_details?.address ||
                              "Same as Buyer"}
                          </div>
                          <div>
                            GSTIN:{" "}
                            {piToApprove.project?.party_details?.gst || "N/A"}
                          </div>
                          <div>
                            STATE CODE:{" "}
                            {piToApprove.project?.party_details?.state || "22"}
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td style={styles.headerCell}>TAX TERMS</td>
                        <td style={styles.headerCell} colSpan={2}>
                          PAYMENT TERMS
                        </td>
                      </tr>

                      <tr>
                        <td style={styles.cell}>
                          {Array.isArray(piToApprove.tax_terms) &&
                            piToApprove.tax_terms.length > 0 ? (
                            piToApprove.tax_terms.map((taxTerm, index) => (
                              <div key={index}>
                                {index + 1}) {taxTerm.term || "N/A"}
                              </div>
                            ))
                          ) : (
                            <>
                              <div>
                                1) GST {piToApprove.gst_percent || "0"}% Extra
                                as Applicable
                              </div>
                              <div>2) Freight F.O.R. HFAL Site</div>
                            </>
                          )}
                        </td>
                        <td style={styles.cell} colSpan={2}>
                          {Array.isArray(piToApprove.payment_terms) &&
                            piToApprove.payment_terms.length > 0 ? (
                            piToApprove.payment_terms.map(
                              (paymentTerm, index) => (
                                <div key={index}>
                                  {index + 1}) {paymentTerm.term || "N/A"}
                                </div>
                              )
                            )
                          ) : (
                            <div>1) 50% advance, balance on delivery</div>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  {/* ITEMS TABLE - DESKTOP */}
                  <table style={{ ...styles.table, marginTop: "-1px" }}>
                    <thead>
                      <tr>
                        <th style={{ ...styles.headerCell, width: "5%" }}>
                          NO
                        </th>
                        <th style={{ ...styles.headerCell, width: "40%" }}>
                          DESCRIPTION
                        </th>
                        <th style={{ ...styles.headerCell, width: "10%" }}>
                          UOM
                        </th>
                        <th style={{ ...styles.headerCell, width: "10%" }}>
                          QTY.
                        </th>
                        <th style={{ ...styles.headerCell, width: "15%" }}>
                          RATE (Rs.)
                        </th>
                        <th style={{ ...styles.headerCell, width: "20%" }}>
                          AMOUNT (Rs.)
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(piToApprove.project?.items) &&
                        piToApprove.project.items.length > 0 ? (
                        piToApprove.project.items.map((item, i) => (
                          <tr key={i}>
                            <td style={{ ...styles.cell, textAlign: "center" }}>
                              {i + 1}
                            </td>
                            <td style={styles.cell}>
                              {item.description || item.item_name || "N/A"}
                            </td>
                            <td style={{ ...styles.cell, textAlign: "center" }}>
                              {item.uom || "Nos"}
                            </td>
                            <td style={{ ...styles.cell, textAlign: "right" }}>
                              {Number(
                                item.pi_qty || item.quantity || 0
                              ).toFixed(2)}
                            </td>
                            <td style={{ ...styles.cell, textAlign: "right" }}>
                              {Number(item.rate || 0).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </td>
                            <td style={{ ...styles.cell, textAlign: "right" }}>
                              {Number(item.amount || 0).toLocaleString(
                                "en-IN",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td style={{ ...styles.cell, textAlign: "center" }}>
                            1
                          </td>
                          <td style={styles.cell}>
                            {piToApprove.remarks ||
                              `Advance for ${piToApprove.project?.project_name || "N/A"
                              }`}
                          </td>
                          <td style={{ ...styles.cell, textAlign: "center" }}>
                            LS
                          </td>
                          <td style={{ ...styles.cell, textAlign: "right" }}>
                            1
                          </td>
                          <td style={{ ...styles.cell, textAlign: "right" }}>
                            {Number(
                              piToApprove.basic_value || 0
                            ).toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </td>
                          <td style={{ ...styles.cell, textAlign: "right" }}>
                            {Number(
                              piToApprove.basic_value || 0
                            ).toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </td>
                        </tr>
                      )}

                      <tr>
                        <td
                          style={{
                            ...styles.cell,
                            textAlign: "right",
                            fontWeight: "bold",
                          }}
                          colSpan={5}
                        >
                          BASIC VALUE
                        </td>
                        <td
                          style={{
                            ...styles.cell,
                            textAlign: "right",
                            fontWeight: "bold",
                          }}
                        >
                          {Number(piToApprove.basic_value || 0).toLocaleString(
                            "en-IN",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                        </td>
                      </tr>

                      {piToApprove.gst_amount > 0 && (
                        <tr>
                          <td
                            style={{ ...styles.cell, textAlign: "right" }}
                            colSpan={5}
                          >
                            GST @ {piToApprove.gst_percent || 0}%
                          </td>
                          <td style={{ ...styles.cell, textAlign: "right" }}>
                            {Number(piToApprove.gst_amount || 0).toLocaleString(
                              "en-IN",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </td>
                        </tr>
                      )}

                      <tr>
                        <td
                          style={{ ...styles.cell, fontWeight: "bold" }}
                          colSpan={5}
                        >
                          {piToApprove.installment_summary ||
                            `PAYABLE AS ADV @ ${piToApprove.advance_percent || 0
                            }% OF BASIC VALUE`}
                        </td>
                        <td
                          style={{
                            ...styles.cell,
                            textAlign: "right",
                            fontWeight: "bold",
                          }}
                        >
                          {Number(
                            piToApprove.advance_received || 0
                          ).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  {/* REST OF DESKTOP TABLES */}
                  <table style={{ ...styles.table, marginTop: "-1px" }}>
                    <tbody>
                      <tr>
                        <td style={styles.cell}>
                          <div style={styles.bold}>
                            In Words: {piToApprove.amount_in_words || "N/A"}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td style={styles.cell}>
                          {Array.isArray(
                            piToApprove.project?.terms_and_conditions
                          ) &&
                            piToApprove.project.terms_and_conditions.length >
                            0 ? (
                            piToApprove.project.terms_and_conditions
                              .filter(
                                (tc) =>
                                  tc.key === "Jurisdiction" ||
                                  tc.key === "Rejection/Claim" ||
                                  tc.key === "Remark"
                              )
                              .map((tc, index) => (
                                <div key={index}>
                                  {index + 1}. {tc.key}: {tc.value}
                                </div>
                              ))
                          ) : (
                            <>
                              <div>
                                1. Dispute, if any is subject to Durg
                                Jurisdiction only.
                              </div>
                              <div>
                                2. Interest @22% per annum will be charged after
                                7 days of the presentation of bill.
                              </div>
                            </>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td style={styles.cell}>
                          <Grid container>
                            <Grid item xs={7}>
                              <div
                                style={{
                                  textDecoration: "underline",
                                  fontWeight: "bold",
                                }}
                              >
                                Details for Bank Transfer:-
                              </div>
                              {piToApprove.bank_details ? (
                                <>
                                  <div style={{ marginTop: "5px" }}>
                                    <strong>A/C NO.:</strong>{" "}
                                    {piToApprove.bank_details.account_number ||
                                      "N/A"}
                                  </div>
                                  <div>
                                    <strong>BANK NAME:</strong>{" "}
                                    {piToApprove.bank_details.bank_name ||
                                      "N/A"}
                                    {piToApprove.bank_details.branch_name &&
                                      `, BRANCH - ${piToApprove.bank_details.branch_name}`}
                                  </div>
                                  <div>
                                    <strong>IFSC CODE:</strong>{" "}
                                    {piToApprove.bank_details.ifsc_code ||
                                      "N/A"}
                                  </div>
                                  <div>
                                    <strong>MICR CODE:</strong> N/A
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div style={{ marginTop: "5px" }}>
                                    <strong>A/C NO.:</strong> 22222563453
                                  </div>
                                  <div>
                                    <strong>BANK NAME:</strong> HDFC, BRANCH -
                                    Sun and Suns
                                  </div>
                                  <div>
                                    <strong>IFSC CODE:</strong> AAAA0001ABC
                                  </div>
                                  <div>
                                    <strong>MICR CODE:</strong> N/A
                                  </div>
                                </>
                              )}
                            </Grid>
                            <Grid item xs={5}>
                              <div>
                                Transfer the payment through (NEFT/RTGS) in
                                below account:
                              </div>
                            </Grid>
                          </Grid>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <table style={{ ...styles.table, marginTop: "-1px" }}>
                    <tbody>
                      <tr>
                        <td
                          style={{
                            ...styles.cell,
                            width: "50%",
                            textAlign: "center",
                            fontWeight: "bold",
                          }}
                        >
                          OUR GST INFORMATION
                        </td>
                        <td
                          style={{
                            ...styles.cell,
                            width: "50%",
                            textAlign: "center",
                            fontWeight: "bold",
                          }}
                        >
                          AUTHORIZATION
                        </td>
                      </tr>
                      <tr>
                        <td style={{ ...styles.cell, height: "80px" }}>
                          <div>GSTIN: {divisionLocalStorage?.gst_no || "22AAHFK2314C1Z4"}</div>
                          <div>PAN NO.: {divisionLocalStorage?.pan_no || "AAHFK2314C1"}</div>
                        </td>
                        <td
                          style={{
                            ...styles.cell,
                            textAlign: "center",
                            verticalAlign: "bottom",
                          }}
                        >
                          <div>For CRANOIST MHE PVT. LTD.</div>
                          <div style={{ marginTop: "30px" }}>(Signature)</div>
                          <div>Auth. Signatory</div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Box>
              )}
            </Box>
          )}
        </DialogContent>

        {/* RESPONSIVE FOOTER - SAME AS BEFORE */}
        <DialogActions
          sx={{
            p: isMobile ? 1.5 : 2,
            bgcolor: "#f5f5f5",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? 1.5 : 2,
            alignItems: "stretch",
            position: "sticky",
            bottom: 0,
            borderTop: "2px solid #e0e0e0",
          }}
        >
          {/* <TextField
            fullWidth
            size="small"
            placeholder="Enter Remarks (Required for Rejection)"
            value={remarkInput}
            onChange={(e) => setRemarkInput(e.target.value)}
            variant="outlined"
            multiline={isMobile}
            rows={isMobile ? 2 : 1}
            sx={{
              bgcolor: "white",
              flex: isMobile ? "1" : "1 1 60%",
              "& .MuiInputBase-root": {
                fontSize: isMobile ? "0.85rem" : "0.9rem",
              },
            }}
          /> */}

          <Box
            sx={{
              display: "flex",
              gap: 1,
              width: isMobile ? "100%" : "auto",
              flexDirection: isMobile ? "column" : "row",
            }}
          >
            {/* <Button
              fullWidth={isMobile}
              variant="contained"
              color="error"
              onClick={() => executeApproval("Rejected")}
              disabled={
                !remarkInput.trim() ||
                piToApprove?.status === "Approved" ||
                piToApprove?.status === "Rejected"
              }
              sx={{
                fontSize: isMobile ? "0.85rem" : "0.9rem",
                py: isMobile ? 1.2 : 0.75,
              }}
            >
              Reject
            </Button>
            <Button
              fullWidth={isMobile}
              variant="contained"
              color="success"
              onClick={() => executeApproval("Approved")}
              disabled={
                piToApprove?.status === "Approved" ||
                piToApprove?.status === "Rejected"
              }
              sx={{
                fontSize: isMobile ? "0.85rem" : "0.9rem",
                py: isMobile ? 1.2 : 0.75,
              }}
            >
              Approve
            </Button>
            <Button
              fullWidth={isMobile}
              variant="contained"
              color="primary"
              onClick={() =>
                navigate(
                  `/dashboard/performaInvoice/${piToApprove.invoice_number}`,
                  {
                    state: { piToApprove },
                  }
                )
              }
              disabled={
                piToApprove?.status === "Approved" ||
                piToApprove?.status === "Rejected"
              }
              sx={{
                fontSize: isMobile ? "0.85rem" : "0.9rem",
                py: isMobile ? 1.2 : 0.75,
              }}
            >
              Edit
            </Button> */}
            <Button
              variant="outlined"
              startIcon={<CloseIcon />}
              onClick={() => {
                setApprovalDialogOpen(false);
                setRemarkInput("");
                setPIToApprove(null);
              }}
            >
              Close
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ProformaInvoiceTable;
